import React from "react";
import { NETSTAT_SWITCH_URL } from "../../../Optics/OpticApiConfig";
import { ROLE_ADMIN, ROLE_ENGINNER } from "../../../Optics/Constants/ConstantsOptics";

const WifiInfoBdDescription = ({ content, role }) => {
  return (
    <div className="divСommunicationsDrawer" 
          style={{ border: '1px solid #ffea97ff', padding: '10px', fontSize: '14px', boxShadow: "0px 0px 6px 0px #000000ff",
                    background: "linear-gradient(to bottom,  #292929ff, #353535ff)"
          }}
     >  
        
     <label style={{ color: "#ffea97ff", marginBottom: "2px", textShadow: "1px 1px 2px #000000ff", fontSize: '18px' }}>Сведения из БД</label>
      <hr className='hr-gradient' style={{marginBottom: '5px'}}/>

    <div className="infoCard" style={{ display: "block", boxShadow: "0px 0px 6px 0px #000000ff" }}>
        <div><span style={{color: '#181818ff', fontWeight: 'bold'}}>Ip:</span> <span style={{textShadow: "1px 1px 2px #000000ff", color:'#f0f0f0ff'}}>{content.ip}</span></div>
        <div><span style={{color: '#181818ff', fontWeight: 'bold'}}>Mac:</span> <span style={{textShadow: "1px 1px 2px #000000ff", color:'#f0f0f0ff'}}>{content.mac}</span></div>
        <div><span style={{color: '#181818ff', fontWeight: 'bold'}}>Azimuth:</span>{" "}<span style={{textShadow: "1px 1px 2px #000000ff", color:'#f0f0f0ff'}}>{content.azimuth}°</span></div>

        {(role == ROLE_ADMIN || role === ROLE_ENGINNER) ? ( 
          <>
            <div><span style={{color: '#181818ff', fontWeight: 'bold'}}>Login:</span>{" "}<span style={{textShadow: "1px 1px 2px #000000ff", color:'#f0f0f0ff'}}>{content.login}</span></div>
            <div><span style={{color: '#181818ff', fontWeight: 'bold'}}>Password:</span> <span style={{textShadow: "1px 1px 2px #000000ff", color:'#f0f0f0ff'}}>{content.password}</span></div>
          </>
        ) : null}
      
        <div><span style={{color: '#181818ff', fontWeight: 'bold'}}>Uplink (ip/port):</span> <span style={{textShadow: "1px 1px 2px #000000ff"}}>
            <a
                  href={`${NETSTAT_SWITCH_URL}?ip=${content.uplinkIp}&port=${content.uplinkPort}`}
                  target="_blank"
                  rel="noreferrer"
                  style={{  color: "#a3b4ffff", fontWeight: 'bold' }}
                >
                   {content.uplinkIp} / {content.uplinkPort}
                </a>

          </span>
        </div>
        {content.controllerIp && (
            <div><span style={{color: '#181818ff', fontWeight: 'bold'}}>Controller:</span> <span style={{textShadow: "1px 1px 2px #000000ff", color:'#f0f0f0ff'}}>{content.controllerIp}</span></div>
        )}
    </div>  
    </div>
  );
};
 
export default WifiInfoBdDescription;